import { IErrorUrlModule } from 'tag/ts/tag/interfaces/config/error/IErrorUrlModule';

/**
 * @description Create error anchor tag with url params
 */
export const createErrorUrl = ( copy: string, url: string, target: string, color: string, refreshPage: boolean = false ): string => {
	let onclick = `this.style.color='${color};`;
	if ( refreshPage === true ) onclick += 'window.location.reload();';

	return `
			<a href="${url}"
			target="${target}"
			style="color:${color};"
			onmouseover="this.style.color='${color};'"
			onmouseout="this.style.color='${color};'"
			onmousedown="this.style.color='${color};'"
			onmouseup="this.style.color='${color};'"
			onclick="${onclick}">${copy}</a>.`;
};

/* eslint-disable */
/**
 * @description Error Urls
 */
export const ErrorUrl: IErrorUrlModule = {
	// INFO: VTG Player Urls
	DEFAULT: {
		copy: 'here',
		url: 'https://cbsi.secure.force.com/CBSi/articles/FAQ/Why-am-I-seeing-the-video-is-currently-unavailable-error-I-m-trying-to-stream-CBS-All-Access?retURL=%2FCBSi%2Fapex%2FKnowledgeHome&popup=false&faqTitle=Why+am+I+seeing+the+%E2%80%9Cvideo+is+currently+unavailable%E2%80%9D+error%3F++I%27m+trying+to+stream+CBS+All+Access.&referer=cbs.com%2Faa&template=template_aa17',
		target: '_blank',
		refreshPage: false
	},
	'1': {
		copy: 'here',
		url: 'https://cbsi.secure.force.com/CBSi/articles/FAQ/Why-am-I-seeing-the-video-is-currently-unavailable-error-I-m-trying-to-stream-CBS-All-Access?retURL=%2FCBSi%2Fapex%2FKnowledgeHome&popup=false&faqTitle=Why+am+I+seeing+the+%E2%80%9Cvideo+is+currently+unavailable%E2%80%9D+error%3F++I%27m+trying+to+stream+CBS+All+Access.&referer=cbs.com%2Faa&template=template_aa17',
		target: '_blank',
		refreshPage: false
	},
	'2': {
		copy: 'cbs.com/vpnhelp',
		url: 'https://cbs.com/vpnhelp',
		target: '_blank',
		refreshPage: false
	},
	'3': {
		copy: 'Return home',
		url: 'https://www.cbs.com',
		target: '_self',
		refreshPage: false
	},
	'4': {
		copy: 'FAQ',
		url: 'https://cbsi.secure.force.com/CBSi/articles/FAQ/Why-am-I-seeing-the-video-is-currently-unavailable-error-I-m-trying-to-stream-CBS-All-Access?retURL=%2FCBSi%2Fapex%2FKnowledgeHome&popup=false&faqTitle=Why+am+I+seeing+the+%E2%80%9Cvideo+is+currently+unavailable%E2%80%9D+error%3F++I%27m+trying+to+stream+CBS+All+Access.&referer=cbs.com%2Faa&template=template_aa17',
		target: '_blank',
		refreshPage: false
	},
	'5': {
		copy: 'Try again',
		url: '',
		target: '_self',
		refreshPage: true
	},

	// INFO: SmartTag Urls
	'6': {
		copy: 'CBS All Access Commercial Free',
		url: 'https://www.cbs.com/all-access/?intcid=CIA-00-10adh2d',
		target: '_self',
		refreshPage: false
	},
	'7': {
		copy: 'CBS All Access Commercial Free',
		url: 'https://www.cbs.com/all-access/account/switch/?intcid=CIA-00-10adh2e',
		target: '_self',
		refreshPage: false
	}
};
/* eslint-enable */